import { render } from "./MiddleButton.vue?vue&type=template&id=651f3b18&scoped=true"
import script from "./MiddleButton.vue?vue&type=script&lang=js"
export * from "./MiddleButton.vue?vue&type=script&lang=js"

import "./MiddleButton.vue?vue&type=style&index=0&id=651f3b18&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/luxgenVueLifeFrontend/home/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-651f3b18"]])

export default __exports__